import { useState } from 'preact/hooks';
import { signOut } from '../auth/session';
import { APP_VERSION } from '../lib/version';
import { navigate } from '../lib/router';
import { Popover } from '../ui/Popover';
import { useFlag } from './hooks';
import { RecentlyRemoved } from './RecentlyRemoved';

// The account button (initial in a circle) and its menu. Items join as their screens are
// built (Kristi, Oct 26): who you are, Feature flags (the admin only), Sign out.
// Consistency pass (R4, Kristi Nov 1): the shared menu, a menu under the button on a laptop and a
// bottom sheet on a phone, with the shared menu rows (44 px on touch).

export function AccountMenu({ email, isAdmin = false }: { email: string; isAdmin?: boolean }) {
  const [open, setOpen] = useState(false);
  const [removed, setRemoved] = useState(false);
  const editOn = useFlag('book_page.edit');
  const initial = (email.trim()[0] ?? '?').toUpperCase();
  const item = (label: string, run: () => void) => (
    <button
      type="button"
      role="menuitem"
      class="menu-item"
      onClick={() => {
        setOpen(false);
        run();
      }}
    >
      <span class="menu-label">{label}</span>
    </button>
  );

  return (
    <span class="pop-host account">
      <button
        type="button"
        class="account-button"
        aria-label="Account"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        {initial}
      </button>
      <Popover open={open} onClose={() => setOpen(false)} label="Account" sheetTitle="Account">
        <div class="menu account-menu" role="menu" aria-label="Account">
          <p class="account-who">Signed in as {email}</p>
          {isAdmin ? item('Feature flags', () => navigate('/flags', { state: { from: window.location.pathname } })) : null}
          {editOn ? item('Recently removed', () => setRemoved(true)) : null}
          {item('Sign out', () => void signOut())}
          <p class="account-version">Reading List {APP_VERSION}</p>
        </div>
      </Popover>
      {removed ? <RecentlyRemoved onClose={() => setRemoved(false)} /> : null}
    </span>
  );
}
